import { render, staticRenderFns } from "./workben_property.vue?vue&type=template&id=17d3c419&scoped=true&"
import script from "./workben_property.vue?vue&type=script&lang=js&"
export * from "./workben_property.vue?vue&type=script&lang=js&"
import style0 from "./workben_property.vue?vue&type=style&index=0&id=17d3c419&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d3c419",
  null
  
)

export default component.exports